import style from 'styled-components';

export const StyledPhotoLinkSection = style.div`
	.flex-centered {
		display: flex;
		justify-content: center;
	}
`;
